import Accordion from "./components/Accordion/Accordion";
import AccordionsBlockProps from "./AccordionsProps.interface";
import styles from "./Accordions.module.scss";

import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import React, { FunctionComponent } from "react";
import useAnchor from "blocks/hooks/useAnchor";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";

const Accordions: FunctionComponent<AccordionsBlockProps> = (props) => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);

    const identifier = useAnchor(props.settings.anchorMenuLabel);
    const { splitClasses, splitStyles } = useSplitBackground(props);

    const accordionSize = props.settings.size ? styles[props.settings.size] : undefined;

    return (
        <section className={combineClasses(styles.wrapper, ...wrapperClasses, accordionSize)} style={{ ...wrapperStyles, ...splitStyles }} id={identifier}>
            <div className={combineClasses(styles.container, ...splitClasses, accordionSize)}>
                {/* Accordions */}
                <div className={styles.list}>
                    {props.content.accordions && props.content.accordions.map((item, index) => {
                        return (
                            <Accordion key={index} {...item} />
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Accordions;
